import * as React from "react";
/**
 * This icon from figma is not available in @fluentui/react-icons
 * So we have to create the react icon component ourselves
 */ export const CheckmarkCircleDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "160",
        height: "160",
        viewBox: "0 0 160 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M79.9997 13.3333C116.819 13.3333 146.666 43.1809 146.666 79.9999C146.666 116.819 116.819 146.667 79.9997 146.667C43.1807 146.667 13.333 116.819 13.333 79.9999C13.333 43.1809 43.1807 13.3333 79.9997 13.3333ZM108.779 58.7203C107.261 57.2016 104.861 57.1004 103.225 58.4166L102.887 58.7203L69.1663 92.4407L57.1126 80.387C55.4854 78.7598 52.8472 78.7598 51.2201 80.387C49.7014 81.9057 49.6001 84.3051 50.9163 85.9412L51.2201 86.2795L66.2201 101.28C67.7388 102.798 70.1382 102.899 71.7743 101.583L72.1126 101.28L108.779 64.6129C110.406 62.9857 110.406 60.3475 108.779 58.7203Z",
        fill: "#978bff"
    }));
